import './are-you-sure-you-are-done.css'

const AreYouSureYouAreDone = ({setIsWarning, checkBoxAndDeleteTask}) => {
    return (
        <div className='are-you-sure-you-are-done__wrapper'>
            <div className='are-you-sure-you-are-done'>
                <div className='are-you-sure-you-are-done__question-mark-icon'>?</div>
                <div className='are-you-sure-you-are-done__title'>Task Complete?</div>
                <div className='are-you-sure-you-are-done__subtitle'>There are still incomplete subtasks. Are you sure you are done with this task?</div>
                <div className='are-you-sure-you-are-done__btn-wrapper'>
                    <div className='are-you-sure-you-are-done__btn__no' onClick={() => setIsWarning(false)}>No</div>
                    <div className='are-you-sure-you-are-done__btn__yes' onClick={() => checkBoxAndDeleteTask()}>Yes</div>
                </div>
            </div>
        </div>
    )
}
export default AreYouSureYouAreDone